// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar-module--navbar--3fN7V","logo":"navbar-module--logo--17pPY","navList":"navbar-module--navList--3M6cP","navLink":"navbar-module--navLink--yVTm2"};